import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { pointActions } from '../../store/modules/point';
import PointCauseSaveWrap from '../../views/point/cause/save/PointCauseSaveWrap';
import { setTrim } from '../../lib/common';

class PointCauseSaveContainer extends Component {
  onSubmit = () => {
    const { form, createPointCause, pointCauseInfo } = this.props;
    const { type, cause } = pointCauseInfo;

    /**
     *  form 유효성 체크
     */
    form.validateFieldsAndScroll((err) => {
      if (err) {
        return;
      }

      createPointCause({
        type,
        cause: setTrim(cause),
      });
    });
  };

  render() {
    const { form, setData } = this.props;

    return <PointCauseSaveWrap form={form} onSubmit={this.onSubmit} setData={setData} />;
  }
}

const mapStateToProps = (state) => {
  return {
    pointCauseInfo: state.point.pointCauseSave.pointCauseInfo,
  };
};

const mapDispatchToProps = {
  setData: pointActions.setData,
  createPointCause: pointActions.createPointCause,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(PointCauseSaveContainer));
